<template>
  <div class="answer-container">
    <div
      v-if="poll.isDisplayed && !isPieChart"
      class="answer answer-displayed"
      :style="{ height:this.answerHeight + 'px'}"
      >
      <img
        v-if="atLeastOneImage"
        class="answer-displayed-image"
        :src="answer.image || imagePlaceholder"
        :style="{height:this.answerHeight + 'px', width:this.answerHeight + 'px'}"
      />
      <div class="answer-displayed-content">
        <div
          class="answer-displayed-text"
          :style="{
            color: invertColor(poll.jsStyle.backgroundColor)
          }"
          v-line-clamp:30="1"
        >
          <span class="answer-number">{{ index + 1 }}</span>
          {{ answer.texts[lang] }}
        </div>
        <div class="answer-displayed-results">
          <div class="answer-result-bar-empty">
            <div
              class="answer-result-bar"
              :style="{
                width: answerPercent(answer) + '%',
                backgroundColor: getBarColor(poll, index)
              }"
            ></div>
          </div>
          <div class="answer-displayed-percentage">
            <div
              class="answer-displayed-chip"
              :style="{
                backgroundColor: getBarColor(poll, index),
                color: invertColor(getBarColor(poll, index))
              }"
            >{{ answerPercent(answer) }} %</div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      :style="{ _backgroundColor: getAnswerColor(poll, index), height:this.answerHeight + 'px'}"
      class="answer answer-undisplayed"
    >
      <img
        v-if="atLeastOneImage"
        class="answer-undisplayed-image"
        :src="answer.image || imagePlaceholder"
        :style="{height:this.answerHeight + 'px', width:this.answerHeight + 'px'}"
      />
      <div class="answer-percentage" 
        :style="{ backgroundColor: getAnswerColor(poll, index), color: invertColor(getAnswerColor(poll, index)) }">
        {{ answerPercent(answer) }} %
      </div>
      <div
        class="answer-undisplayed-text"
        :style="{ color: getAnswerColor(poll, index) }"
      >
        <span v-line-clamp:30="answerLines">{{ answer.texts[lang] }}</span>
      </div>
      <div class="answer-quizz-isgood">
        <v-icon
          v-if="answerIsGood && poll.isDisplayed && !poll.isActive"
          class="quizz-check-icon"
        >check</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import imagePlaceholder from '../assets/image-placeholder.jpg';
import CommonMixin from '../mixins/common.js';
import { mapGetters } from 'vuex';

export default {
  name: 'answer',
  props: {
    ...CommonMixin.props,
    answer: Object,
    index: Number,
    answerHeight: Number
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
    ...CommonMixin.computed,
    answerIsGood() {
      return this.stats.answers && this.stats.answers[this.index].isGood;
    },
    isPieChart() {
      return this.poll.jsStyle.graphType.value === 'pie_chart' || this.poll.jsStyle.graphType.value === 'doughnut_chart';
    }
  },
  data: () => ({
    imagePlaceholder,
    answerLines: 1
  }),
  watch: {
    answerHeight: function (height) {
      this.answerLines = Math.floor(height / 30)
    }
  },
  methods: {
    ...CommonMixin.methods,
    getBarColor(poll, index) {
      if (this.question.type !== 'QUIZZ' || this.answer.isGood) {
        return this.getAnswerColor(poll, index);
      }
      // return a gray bar for wrong quizz answers
      return '#bcbdbd';
    }
  }
};
</script>

<style lang="scss" scoped>
$answer-border-radius: 4px;

.answer-container {
  width: 100%;
}

.answer {
  transition: all 1s;
  display: flex;
  width: 100%;
  overflow: hidden;
}

.answer-displayed {
}

.answer-displayed-image {
  border-top-left-radius: $answer-border-radius;
  border-bottom-left-radius: $answer-border-radius;
  flex: 0 0;
}

.answer-displayed-content {
  width: 100%;
}

.answer-displayed-text {
  display: flex;
  flex: 1;
  font-size: 22px;
  overflow: hidden;
  padding-left: 10px;
}

.answer-number {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 40px;
  padding: 6px;
  font-size: 35px;
  margin-right: 10px;
  background-color: #000000;
  text-align: center;
  display: inline-block;
  color: white !important;
  flex: 0 0 50px;
}

.answer-displayed-percentage {
  flex: 0 0 120px;
  width: 200px;
}

.answer-displayed-chip {
  display: inline-block;
  padding: 0 15px;
  border-radius: 50px;
  margin: 0 20px;
}

.answer-displayed-results {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  margin-left: 10px;
}

.answer-result-bar-empty {
  position: relative;
  flex: 1;
  border-radius: 28px;
  background: rgba(0, 0, 0, 0.05);
  height: 20px;
}

.answer-result-bar {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 2s;
  height: 100%;
  border-radius: 28px;
}

.answer-undisplayed {
}

.answer-undisplayed-image {
  border-top-left-radius: $answer-border-radius;
  border-bottom-left-radius: $answer-border-radius;
  flex: 0 0;
}

.answer-quizz-isgood {
  flex: 0 0 50px;
}

.quizz-check-icon {
  font-size: 50px;
  color: #7be293;
}

.answer-undisplayed-text {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 22px;
  padding-left: 10px;
}
.answer-percentage {
  display: flex;
  align-items: center;
  flex: 0 80px;
  border-radius: 0 10px;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  padding-right: 10px;
}

</style>
